import React from 'react'

export default function Step1Asset (props) {
  return (
    <svg
      width="403"
      height="344"
      viewBox="0 0 403 344"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
      aria-hidden="true"
    >
      <rect
        x="25"
        y="0.00012207"
        width="346"
        height="344"
        rx="172"
        fill="#DFF4F7"
      />
      <path
        d="M277.181 232.431C276.791 232.041 276.791 231.408 277.181 231.017L283.545 224.653C283.936 224.263 284.569 224.263 284.959 224.653C285.35 225.044 285.35 225.677 284.959 226.067L279.302 231.724L284.959 237.381C285.35 237.772 285.35 238.405 284.959 238.795C284.569 239.186 283.936 239.186 283.545 238.795L277.181 232.431ZM317.811 191V192.802H315.811V191H317.811ZM317.811 192.802C317.811 214.85 299.937 232.724 277.888 232.724V230.724C298.832 230.724 315.811 213.746 315.811 192.802H317.811Z"
        fill="#1D1F21"
      />
      <path
        d="M102.63 232.431C103.02 232.041 103.02 231.408 102.63 231.017L96.2656 224.653C95.875 224.263 95.2419 224.263 94.8513 224.653C94.4608 225.044 94.4608 225.677 94.8513 226.067L100.508 231.724L94.8513 237.381C94.4608 237.772 94.4608 238.405 94.8513 238.795C95.2419 239.186 95.875 239.186 96.2656 238.795L102.63 232.431ZM62 191V192.802H64V191H62ZM62 192.802C62 214.85 79.8739 232.724 101.922 232.724V230.724C80.9784 230.724 64 213.746 64 192.802H62Z"
        fill="#1D1F21"
      />
      <rect
        width="151"
        height="162"
        transform="matrix(4.62993e-08 -1 -1 -4.12681e-08 403 191)"
        fill="#1D1F21"
      />
      <path
        d="M260.581 80.2013C259.331 80.2013 258.389 79.8589 257.755 79.1742C257.12 78.5109 256.803 77.5265 256.803 76.2213V69.5771C256.803 68.657 256.659 67.9723 256.37 67.5229C256.101 67.0735 255.669 66.8061 255.073 66.7205C254.842 66.6777 254.727 66.5386 254.727 66.3032V63.5107C254.727 63.254 254.842 63.1149 255.073 63.0935C255.669 63.0079 256.101 62.7404 256.37 62.291C256.659 61.8417 256.803 61.1676 256.803 60.2689V53.7532C256.803 52.4479 257.12 51.4636 257.755 50.8002C258.389 50.1369 259.331 49.8052 260.581 49.8052H263.205C263.301 49.8052 263.378 49.848 263.436 49.9336C263.513 49.9978 263.551 50.0834 263.551 50.1904V53.3038C263.551 53.4108 263.513 53.5071 263.436 53.5927C263.378 53.6569 263.301 53.689 263.205 53.689H262.427C261.965 53.689 261.59 53.8709 261.302 54.2346C261.013 54.5984 260.869 55.0906 260.869 55.7111V60.8788C260.869 61.9273 260.735 62.7725 260.465 63.4144C260.196 64.035 259.773 64.4951 259.197 64.7946C259.081 64.8588 259.081 64.923 259.197 64.9872C259.773 65.3082 260.196 65.7896 260.465 66.4316C260.735 67.0735 260.869 67.9188 260.869 68.9673V74.2633C260.869 74.9053 261.013 75.3974 261.302 75.7398C261.59 76.1036 261.965 76.2854 262.427 76.2854H263.205C263.301 76.2854 263.378 76.3175 263.436 76.3817C263.513 76.4673 263.551 76.5636 263.551 76.6706V79.8161C263.551 79.9231 263.513 80.0087 263.436 80.0729C263.378 80.1585 263.301 80.2013 263.205 80.2013H260.581Z"
        fill="#5CEBA0"
      />
      <line
        x1="277"
        y1="62.0195"
        x2="365"
        y2="62.0195"
        stroke="#D4D7D9"
        strokeWidth="1.96104"
      />
      <line
        x1="277.135"
        y1="73.9625"
        x2="339.166"
        y2="73.9625"
        stroke="#5CEBA0"
        strokeWidth="1.96104"
      />
      <line
        x1="347.119"
        y1="73.9625"
        x2="375.749"
        y2="73.9625"
        stroke="#FCE969"
        strokeWidth="1.96104"
      />
      <line
        x1="277.135"
        y1="85.7312"
        x2="388.472"
        y2="85.7312"
        stroke="#D4D7D9"
        strokeWidth="1.96104"
      />
      <line
        x1="277.135"
        y1="109.268"
        x2="328.032"
        y2="109.268"
        stroke="#FCE969"
        strokeWidth="1.96104"
      />
      <line
        x1="335.988"
        y1="109.268"
        x2="374.161"
        y2="109.268"
        stroke="#5CEBA0"
        strokeWidth="1.96104"
      />
      <line
        x1="277.135"
        y1="121.036"
        x2="359.842"
        y2="121.036"
        stroke="#FD7A7D"
        strokeWidth="1.96104"
      />
      <line
        x1="277.135"
        y1="97.4993"
        x2="364.614"
        y2="97.4993"
        stroke="#D4D7D9"
        strokeWidth="1.96104"
      />
      <line
        x1="277.135"
        y1="133.496"
        x2="334.394"
        y2="133.496"
        stroke="#D4D7D9"
        strokeWidth="1.96104"
      />
      <line
        x1="342.348"
        y1="133.496"
        x2="374.158"
        y2="133.496"
        stroke="#5CEBA0"
        strokeWidth="1.96104"
      />
      <line
        y1="-0.980519"
        x2="50.897"
        y2="-0.980519"
        transform="matrix(1 0 0 -1 277.135 156.232)"
        stroke="#FCE969"
        strokeWidth="1.96104"
      />
      <line
        y1="-0.980519"
        x2="38.1728"
        y2="-0.980519"
        transform="matrix(1 0 0 -1 335.988 156.232)"
        stroke="#5CEBA0"
        strokeWidth="1.96104"
      />
      <line
        y1="-0.980519"
        x2="82.7077"
        y2="-0.980519"
        transform="matrix(1 0 0 -1 277.135 144.464)"
        stroke="#FD7A7D"
        strokeWidth="1.96104"
      />
      <line
        y1="-0.980519"
        x2="87.4793"
        y2="-0.980519"
        transform="matrix(1 0 0 -1 277.135 168)"
        stroke="#5CEBA0"
        strokeWidth="1.96104"
      />
      <line
        y1="-0.980519"
        x2="57.2592"
        y2="-0.980519"
        transform="matrix(1 -6.76713e-08 -1.12939e-07 -1 277.135 132.003)"
        stroke="#D4D7D9"
        strokeWidth="1.96104"
      />
      <line
        y1="-0.980519"
        x2="31.8106"
        y2="-0.980519"
        transform="matrix(1 -6.76713e-08 -1.12939e-07 -1 342.348 132.003)"
        stroke="#5CEBA0"
        strokeWidth="1.96104"
      />
      <rect y="46.7325" width="131" height="144.268" fill="#61C9D7" />
      <rect y="40" width="131" height="8.65605" fill="#05AAC0" />
      <rect x="17" y="69" width="69" height="12" fill="white" />
      <rect x="21" y="73" width="58" height="4" fill="#5CEBA0" />
      <rect x="17" y="94" width="69" height="12" fill="white" />
      <rect x="21" y="98" width="37" height="4" fill="#5CEBA0" />
      <rect
        x="17"
        y="90.1933"
        width="14.7352"
        height="2.03282"
        fill="#565E62"
      />
      <rect x="17" y="65" width="17" height="2" fill="#565E62" />
      <rect x="17" y="119" width="69" height="12" fill="white" />
      <rect x="21" y="123" width="53" height="4" fill="#5CEBA0" />
      <rect
        x="17"
        y="114.349"
        width="27.3653"
        height="2.03282"
        fill="#565E62"
      />
      <rect x="17" y="144" width="69" height="12" fill="white" />
      <rect x="21" y="148" width="42" height="4" fill="#5CEBA0" />
      <rect x="17" y="167" width="39" height="11" fill="#393E42" />
      <rect x="17" y="139" width="27" height="2" fill="#565E62" />
      <rect
        x="112.336"
        y="94.2328"
        width="151.349"
        height="195.636"
        fill="white"
        stroke="#565E62"
        strokeWidth="2"
      />
      <rect
        x="135.941"
        y="156.67"
        width="28.8351"
        height="4.61362"
        fill="#D8D8DD"
      />
      <rect
        x="135.941"
        y="174.74"
        width="28.8351"
        height="4.61362"
        fill="#D8D8DD"
      />
      <rect
        x="135.941"
        y="192.811"
        width="28.8351"
        height="4.61362"
        fill="#D8D8DD"
      />
      <rect
        x="135.941"
        y="165.513"
        width="28.8351"
        height="4.61362"
        fill="#D8D8DD"
      />
      <rect
        x="135.941"
        y="183.583"
        width="28.8351"
        height="4.61362"
        fill="#D8D8DD"
      />
      <rect
        x="135.941"
        y="201.653"
        width="28.8351"
        height="4.61362"
        fill="#D8D8DD"
      />
      <rect
        x="135.941"
        y="223.952"
        width="28.8351"
        height="4.61362"
        fill="#D8D8DD"
      />
      <rect
        x="135.941"
        y="233.179"
        width="28.8351"
        height="4.61362"
        fill="#D8D8DD"
      />
      <rect
        x="135.793"
        y="265.09"
        width="29.0835"
        height="4.62692"
        fill="#D8D8DD"
      />
      <rect
        x="135.793"
        y="257.819"
        width="29.0835"
        height="4.62692"
        fill="#D8D8DD"
      />
      <rect
        x="135.941"
        y="120.53"
        width="28.8351"
        height="4.61362"
        fill="#D8D8DD"
      />
      <rect
        x="135.941"
        y="130.142"
        width="49.9808"
        height="4.61362"
        fill="#D8D8DD"
      />
      <rect
        x="168.623"
        y="156.67"
        width="71.8955"
        height="4.61362"
        fill="#D8D8DD"
      />
      <rect
        x="168.623"
        y="174.74"
        width="71.8955"
        height="4.61362"
        fill="#D8D8DD"
      />
      <rect
        x="168.623"
        y="192.811"
        width="71.8955"
        height="4.61362"
        fill="#D8D8DD"
      />
      <rect
        x="168.623"
        y="165.513"
        width="71.8955"
        height="4.61362"
        fill="#D8D8DD"
      />
      <rect
        x="168.623"
        y="183.583"
        width="71.8955"
        height="4.61362"
        fill="#D8D8DD"
      />
      <rect
        x="168.623"
        y="201.653"
        width="71.8955"
        height="4.61362"
        fill="#D8D8DD"
      />
      <rect
        x="121.25"
        y="214.194"
        width="2.64396"
        height="2.64396"
        fill="#0F8548"
      />
      <rect
        x="121.25"
        y="244.599"
        width="2.64396"
        height="2.64396"
        fill="#0F8548"
      />
      <rect
        x="176.111"
        y="214.194"
        width="2.64396"
        height="2.64396"
        fill="#0F8548"
      />
      <rect
        x="176.111"
        y="244.599"
        width="2.64396"
        height="2.64396"
        fill="#0F8548"
      />
      <rect
        x="124.502"
        y="217.554"
        width="50.9966"
        height="26.6373"
        stroke="#0F8548"
        strokeWidth="1.81333"
      />
      <rect
        x="168.842"
        y="137.519"
        width="2.64396"
        height="2.64396"
        fill="#0F8548"
      />
      <rect
        x="168.842"
        y="152.061"
        width="2.64396"
        height="2.64396"
        fill="#0F8548"
      />
      <rect
        x="223.703"
        y="137.519"
        width="2.64396"
        height="2.64396"
        fill="#0F8548"
      />
      <rect
        x="223.703"
        y="152.061"
        width="2.64396"
        height="2.64396"
        fill="#0F8548"
      />
      <rect
        x="172.393"
        y="141.07"
        width="50.4048"
        height="10.0845"
        stroke="#0F8548"
        strokeWidth="1.81333"
      />
      <rect
        x="223.6"
        y="117.07"
        width="15.7632"
        height="15.7632"
        fill="#D9D9D9"
      />
    </svg>
  )
}
